var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrigadeChipsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.9986,
    height: 19.9986,
    rx: 9.99931,
    fill: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99931 0C4.47684 0 0 4.47684 0 9.99931C0 10.1332 0.00263315 10.2666 0.0078505 10.3992C0.217762 5.06213 4.61078 0.799805 9.99931 0.799805C15.3878 0.799805 19.7809 5.06213 19.9908 10.3992C19.996 10.2666 19.9986 10.1332 19.9986 9.99931C19.9986 4.47684 15.5218 0 9.99931 0Z",
    fill: "white",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99971 19.9985C15.5222 19.9985 19.999 15.5217 19.999 9.99923C19.999 9.86529 19.9964 9.73198 19.9912 9.59932C19.7813 14.9364 15.3882 19.1987 9.99971 19.1987C4.61118 19.1987 0.218169 14.9364 0.00825782 9.59932C0.00304121 9.73198 0.000407151 9.86529 0.000407139 9.99922C0.000406657 15.5217 4.47725 19.9985 9.99971 19.9985Z",
    fill: "#030303",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17 2H10.82L11.34 3.7L12.69 4.13L14.12 3.05L15.45 4L14.85 5.68L15.68 6.81L17.49 6.76L18 8.3L16.51 9.3V10.7L18 11.7L17.49 13.24L15.68 13.19L14.85 14.32L15.45 16L14.12 16.95L12.69 15.87L11.34 16.3L10.82 18H9.17L8.66 16.3L7.31 15.87L5.88 16.95L4.55 16L5.15 14.32L4.32 13.19L2.51 13.24L2 11.7L3.49 10.7V9.3L2 8.3L2.51 6.76L4.32 6.81L5.15 5.68L4.55 4L5.88 3.05L7.31 4.13L8.66 3.7L9.17 2Z",
    fill: "#A0A0A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10C15 11.3261 14.4732 12.5979 13.5355 13.5355C12.5979 14.4732 11.3261 15 10 15C8.67392 15 7.40215 14.4732 6.46447 13.5355C5.52678 12.5979 5 11.3261 5 10C5 8.67392 5.52678 7.40215 6.46447 6.46447C7.40215 5.52678 8.67392 5 10 5C11.3261 5 12.5979 5.52678 13.5355 6.46447C14.4732 7.40215 15 8.67392 15 10Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6998 10C14.6946 10.612 14.5689 11.2169 14.3298 11.7803C14.0908 12.3437 13.7431 12.8544 13.3067 13.2834C12.8702 13.7125 12.3536 14.0513 11.7862 14.2806C11.2188 14.51 10.6118 14.6253 9.9998 14.62C9.38784 14.6253 8.78083 14.51 8.21343 14.2806C7.64603 14.0513 7.12936 13.7125 6.69292 13.2834C6.25648 12.8544 5.90882 12.3437 5.66979 11.7803C5.43076 11.2169 5.30504 10.612 5.2998 10C5.30184 9.21825 5.50308 8.44992 5.88451 7.76755C6.26594 7.08517 6.81498 6.51126 7.4798 6.1C8.18689 5.65818 8.9984 5.41155 9.83175 5.3852C10.6651 5.35885 11.4906 5.55372 12.2242 5.94998C12.9578 6.34624 13.5733 6.92975 14.0081 7.64114C14.443 8.35253 14.6816 9.16642 14.6998 10Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5301 10.11L10.2901 10.45L7.83008 8.73999L8.07008 8.39999L10.5301 10.11Z",
    fill: "#3C3C3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60021 10.38L9.47021 10.13L12.8002 8.39999L12.9302 8.64999L9.60021 10.38Z",
    fill: "#3C3C3B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1899 9.74C10.2239 9.76385 10.2528 9.79431 10.2748 9.82955C10.2969 9.8648 10.3116 9.90412 10.3181 9.94517C10.3246 9.98621 10.3229 10.0282 10.3129 10.0685C10.3028 10.1088 10.2848 10.1468 10.2599 10.18C10.2097 10.2488 10.1348 10.2956 10.051 10.3105C9.96709 10.3254 9.8807 10.3073 9.80987 10.26C9.77473 10.236 9.74473 10.2052 9.72163 10.1695C9.69853 10.1337 9.6828 10.0937 9.67535 10.0518C9.6679 10.0099 9.66888 9.96693 9.67825 9.92541C9.68761 9.88389 9.70516 9.84465 9.72987 9.81C9.78175 9.73994 9.85925 9.69325 9.94543 9.68013C10.0316 9.66702 10.1195 9.68854 10.1899 9.74Z",
    fill: "#3C3C3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrigadeChipsIcon);
export default __webpack_public_path__ + "static/media/brigade_chips_icon.dc745d7a2ccd6541d3786ebd7c2cac9a.svg";
export { ForwardRef as ReactComponent };